module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lang) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('h1', [_vm._v(_vm._s(_vm.lang.interface.name))]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "random"
    }
  }, [_vm._v(_vm._s(_vm.lang.interface.reroll))])], 1), _vm._v(" "), _c('div', {
    staticClass: "floating-header-padding"
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "lang": _vm.lang
    }
  }), _vm._v(" "), _c('footer', [_c('p', _vm._l((_vm.lang.interface.footerParts), function(part) {
    return _c('span', [(part.url) ? _c('a', {
      attrs: {
        "href": part.url
      }
    }, [_vm._v(_vm._s(part.text))]) : _c('span', [_vm._v(_vm._s(part))])])
  })), _vm._v(" "), _c('p', {
    staticClass: "lang-select"
  }, _vm._l((_vm.languageNames), function(lang, code) {
    return _c('router-link', {
      key: code,
      attrs: {
        "to": '/' + (code === 'en' ? '' : code + '/') + _vm.$route.params.seed
      }
    }, [_vm._v("\n        " + _vm._s(lang) + "\n      ")])
  }))])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b21230e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 71
// module chunks = 4